"use client";

import { useEffect } from "react";
import { useUIStore } from "@/stores/ui-store";
import { X } from "lucide-react";

export function NotificationToast() {
  const notifications = useUIStore((s) => s.notifications);
  const removeNotification = useUIStore((s) => s.removeNotification);

  useEffect(() => {
    if (notifications.length === 0) return;

    const latest = notifications[notifications.length - 1];
    const timer = setTimeout(() => {
      removeNotification(latest.id);
    }, 8000);

    return () => clearTimeout(timer);
  }, [notifications, removeNotification]);

  return (
    <div className="absolute top-16 right-4 z-50 flex flex-col gap-2 pointer-events-none">
      {notifications.map((notif) => (
        <div
          key={notif.id}
          data-testid="notification-toast"
          className={`pointer-events-auto animate-slide-in-right flex items-center gap-3 px-4 py-3 rounded-lg border-2 border-[#1a1a1a] font-mono text-sm bg-[#f5ecd6] shadow-[3px_3px_0_#1a1a1a] ${
            notif.type === "xp"
              ? "text-[#c5a83a]"
              : notif.type === "success"
              ? "text-[#5c7935]"
              : "text-[#3d6890]"
          }`}
        >
          <span className="font-bold">{notif.message}</span>
          <button
            onClick={() => removeNotification(notif.id)}
            className="text-[#8a7a5c] hover:text-[#1a1a1a] transition-colors cursor-pointer"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
    </div>
  );
}
